<app-tab>
  <dx-data-grid
    id="fieldsGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{ stateStorageKey: 'app-field-grid-v2' }"
    [libGridTitle]="{ text: 'Parcelles' }"
    [allowColumnResizing]="false"
    [columnHidingEnabled]="false"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onRowUpdating)="onRowUpdating($event)"
  >
    <dxi-column
      caption="ID"
      width="8%"
      dataField="id"
      sortOrder="desc"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataType="number"
    >
    </dxi-column>

    <dxi-column
      caption="Couleur"
      width="auto"
      cellTemplate="colorTemplate"
      [allowSorting]="false"
      [allowFiltering]="false"
      [allowEditing]="false"
      dataField="color"
    >
      <div *dxTemplate="let cellInfo of 'colorTemplate'">
        <span
          style="width: 18px; height: 18px"
          class="block border border-solid border-gray-300 mx-2"
          [ngStyle]="{ backgroundColor: cellInfo.data.color || '#ffffff' }"
        ></span>
      </div>
      <dxo-form-item editorType="dxColorBox"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      *ngIf="
        systemColumns.length > 0 &&
        (canListThirdPartSystems || canEditThirdPartSystems)
      "
      caption="Systèmes extérieurs"
      [columns]="systemColumns"
    >
    </dxi-column>

    <dxi-column caption="Code" width="8%" dataType="string" dataField="code">
    </dxi-column>

    <dxi-column caption="Nom" width="auto" dataField="name">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Culture"
      cellTemplate="cropTemplate"
      [allowEditing]="false"
      [calculateFilterExpression]="calculateFilterExpression"
      dataField="crop.name"
    >
      <div *dxTemplate="let cellInfo of 'cropTemplate'">
        <a
          href="#"
          (click)="showCropsFromColumn(cellInfo.data)"
          [title]="cellInfo.data?.crop?.path_str || 'Non Disponible'"
          class="border-b border-dotted border-gray-700"
          >{{ cellInfo.data?.crop?.name || "NA" }}</a
        >
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxo-lookup
        [dataSource]="crops | async"
        [allowClearing]="true"
        displayExpr="name"
        valueExpr="name"
      >
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      caption="Superficie Cultivée"
      width="8%"
      format="#0.## Ha"
      dataType="number"
      [allowEditing]="false"
      cellTemplate="cropAreaTemplate"
      dataField="field_crop_cadastral_area"
    >
      <div *dxTemplate="let cellInfo of 'cropAreaTemplate'">
        {{ cellInfo.value }} ({{
          ((cellInfo.data?.field_crop_percent || 0) * 100).toFixed(1)
        }}%)
      </div>
    </dxi-column>

    <dxi-column
      caption="Superficie Carte (Ha)"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      width="8%"
      [customizeText]="hectareUnit"
      dataType="number"
      dataField="polygon_area"
    >
    </dxi-column>

    <dxi-column
      caption="Irriguée?"
      width="auto"
      [showEditorAlways]="false"
      falseText="Bour"
      trueText="Irriguée"
      dataType="boolean"
      dataField="is_irrigated"
    >
      <dxo-form-item editorType="dxCheckBox"></dxo-form-item>
    </dxi-column>

    <dxi-column
      caption="Domaine"
      width="auto"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="domain_name"
    >
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{ visible: false }"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false"
    >
      <div *dxTemplate="let cellInfo of 'domainChooser'">
        <app-user-domains-chooser
          (valueChange)="cellInfo.setValue($event)"
          [id]="cellInfo.value"
        ></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column type="buttons" [width]="110">
      <dxi-button
        hint="Cultures"
        icon="ld-crop"
        [visible]="canEdit"
        [onClick]="showCrops"
      ></dxi-button>
      <dxi-button
        hint="Plan Parcellaires"
        icon="ld-plot-plan"
        [visible]="canEdit"
        [onClick]="openEditor"
      ></dxi-button>
      <dxi-button
        hint="Télecharger KML"
        icon="download"
        [visible]="canEdit"
        [onClick]="downloadKML"
      ></dxi-button>
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxo-summary>
      <dxi-total-item
        column="field_crop_cadastral_area"
        summaryType="sum"
        valueFormat="#0.## Ha"
      >
      </dxi-total-item>
    </dxo-summary>

    <dxo-editing
      mode="batch"
      [allowDeleting]="canDelete"
      [allowAdding]="false"
      [selectTextOnEditStart]="true"
      [allowUpdating]="canEdit"
    >
      <dxo-popup width="50%" [height]="400"></dxo-popup>

      <dxo-form labelLocation="top">
        <dxi-item itemType="group" colSpan="2" colCount="2">
          <dxi-item dataField="code"></dxi-item>
          <dxi-item dataField="name"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colSpan="2" colCount="2">
          <dxi-item dataField="domain_id"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colSpan="2" colCount="2">
          <dxi-item dataField="color"></dxi-item>
          <dxi-item itemType="group" colSpan="1" colCount="3">
            <dxi-item dataField="polygon"></dxi-item>
            <dxi-item dataField="is_irrigated"></dxi-item>
          </dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export
      [enabled]="true"
      fileName="liste-parcelles"
      [allowExportSelectedData]="true"
    ></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-selection selectAllMode="page" mode="multiple"></dxo-selection>
  </dx-data-grid>

  <dx-popup
    [width]="250"
    [height]="240"
    title="Fichiers KML"
    [(visible)]="isMassUploadVisible"
    contentTemplate="popupContent"
  >
    <div *dxTemplate="let data of 'popupContent'">
      <input
        class="hidden"
        type="file"
        multiple
        accept=".kml"
        (change)="handleKMLFiles($event.target.files)"
        #file
      />

      <app-user-domains-chooser
        (valueChange)="massUploadDomainID = $event"
      ></app-user-domains-chooser>
      <div class="p-1"></div>
      <dx-color-box [(value)]="massUploadColor"></dx-color-box>
      <div class="p-1"></div>
      <dx-button
        stylingMode="contained"
        text="Charger les ficheirs"
        type="default"
        [disabled]="!!!massUploadDomainID"
        [width]="250"
        (onClick)="file.click()"
      >
      </dx-button>
    </div>
  </dx-popup>

  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#main-card' }"
    [(visible)]="isLoadingKML"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
  >
  </dx-load-panel>
</app-tab>

<app-field-crops-popup></app-field-crops-popup>
